import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import lodash from 'lodash';
import { v4 as uuid, } from 'uuid';
import Confirm from '../../confirm/Confirm';
import AsyncActionButton from '../../button/AsyncActionButton';
import TenantService from '../../../service/TenantService';

class BatchPay extends React.Component {
  constructor(props) {
    super(props);

    this.onCustomerIdChange = this.onCustomerIdChange.bind(this);

    this.onPaymentAccountIdChange = this.onPaymentAccountIdChange.bind(this);

    this.state = {
      isReady: false,
      customerId: '',
      paymentAccountId: '',
      isConfirmationOpen: false,
      parcels: '',
    };

    TenantService.getAllServiceOfferings().then(({ data, }) => {
      const combo = (
        <div>
          <select className="form-select mt-2 me-2">
            {data.serviceOfferings.map(serviceOffering => (
              <option key={uuid()} value={serviceOffering._id}>
                {lodash.startCase(serviceOffering.serviceOfferingName)}
              </option>
            ))}
          </select>
        </div>
      );
      this.setState({
        comboBox: combo,
        isReady: true,
      });
    });
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.setState({
        customerId: requestedState.customerId,
        paymentAccountId: requestedState.paymentAccountId,
        parcels: requestedState.parcels,
      });
    }
  }

  onConfirmationClose() {
    this.setState({
      isConfirmationOpen: false,
    });
  }

  onConfirmationOpen() {
    this.setState({
      isConfirmationOpen: true,
    });
  }

  onCustomerIdChange(event) {
    this.setState({ customerId: event.target.value, });
  }

  onPaymentAccountIdChange(event) {
    this.setState({ paymentAccountId: event.target.value, });
  }

  onParcelsChange(event) {
    this.setState({ parcels: event.target.value, });
  }

  reset() {
    this.setState({
      isReady: false,
      customerId: '',
      paymentAccountId: '',
      parcels: '',
    });
  }

  render() {
    const {
      comboBox, isReady, customerId, paymentAccountId, isLoading, isConfirmationOpen, parcels,
    } = this.state;
    if (!isReady) {
      return null;
    }

    return (
      <div className="container">

        <Form.Group className="mb-3" controlId="formBasicCustomer" style={{ marginTop: '25px', }}>
          <Form.Label>Service Offering</Form.Label>
          {comboBox}

          <Form.Label style={{ marginTop: '25px', }}>Customer Id</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter a customer id."
            value={customerId}
            onChange={event => this.onCustomerIdChange(event)}
          />

          <Form.Label style={{ marginTop: '25px', }}>Payment Account Id</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter a payment account id."
            value={paymentAccountId}
            onChange={event => this.onPaymentAccountIdChange(event)}
          />

          <Form.Label htmlFor="parcels" style={{ marginTop: '25px', }}>
            Bulk Parcels to Pay
          </Form.Label>
          <Form.Control
            as="textarea"
            name="parcels"
            id="parcels"
            placeholder="Comma seperated list of parcel numbers."
            rows="10"
            cols="100"
            onChange={event => this.onParcelsChange(event)}
            // className="form-control-plaintext"
            // style={{ border: 'solid 1px', }}
          />
        </Form.Group>
        <Confirm
          isLoading={isLoading}
          title="Refund"
          content={`Are you sure you want to want to pay these bills: ${parcels}?`}
          open={isConfirmationOpen}
          onClose={() => this.onConfirmationClose()}
          onYes={() => this.onConfirmationClose()}
          onNo={() => this.onConfirmationClose()}
        />
        <div className="row justify-content-center mt-3 m-1">
          <div className=" m-1">
            <AsyncActionButton
              isLoading={isLoading}
              onClick={() => this.onConfirmationOpen()}
              contents="submit"
              variant="light"
            />
          </div>
          <button
            type="button"
            className="btn btn-light m-1"
            onClick={() => this.setState({ isConfirmationOpen: true, isReady: true, })}
          >
            reset
          </button>
        </div>
      </div>
    );
  }
}

BatchPay.defaultProps = {
  requestedState: undefined,
};

BatchPay.propTypes = {
  requestedState: PropTypes.instanceOf(Object),
};

export default BatchPay;
